import AppAdapter from 'adapters/app';

class PromoCodeAdapter extends AppAdapter {
  constructor(props) {
    super(props)
  }

	static userId = '';
	static action = '';

}

export default PromoCodeAdapter;